// src/components/FollowPanel.tsx
import React, { useState } from "react";
import { theme } from "@/styles/theme";

type SocialLink = {
  id: string;
  label: string;
  iconSrc: string;
  href: string;
};

const SOCIAL_LINKS: SocialLink[] = [
  {
    id: "x",
    label: "X",
    iconSrc: "/images/social/Icon-X.png",
    href: "https://x.com/ThePuzzleBros",
  },
  {
    id: "discord",
    label: "Discord",
    iconSrc: "/images/social/Icon-Discord.png",
    href: "https://discord.gg/BbWQffVz",
  },
  {
    id: "instagram",
    label: "Instagram",
    iconSrc: "/images/social/Icon-Instagram.png",
    href: "https://www.instagram.com/thepuzzlebros/",
  },
  {
    id: "linkedin",
    label: "LinkedIn",
    iconSrc: "/images/social/Icon-Linkedin.png",
    href: "https://www.linkedin.com/company/puzzlebros",
  },
];

export function FollowPanel() {
  const [hoveredId, setHoveredId] = useState<string | null>(null);
  const [pressedId, setPressedId] = useState<string | null>(null);

  return (
    <div
      style={{
        background: theme.colors.DarkGray,
        border: `1px solid ${theme.colors.White}`,
        boxShadow: `2px 2px 0 ${theme.colors.DarkGray}`,
        padding: 0,
        height: "100%",
        minHeight: 100,
        boxSizing: "border-box",
        overflow: "hidden",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <div
        style={{
          flex: 1,
          padding: "14px 16px 12px 16px",
          boxSizing: "border-box",
          display: "flex",
          flexDirection: "column",
          gap: 12,
        }}
      >
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            gap: 14,
          }}
        >
          {SOCIAL_LINKS.map((item) => {
            const isHovered = hoveredId === item.id;
            const isPressed = pressedId === item.id;

            let borderColor = "transparent";
            let tileBackground: string = "transparent";

            if (isPressed) {
              tileBackground = "rgba(223, 223, 223, 0.20)";
              borderColor = theme.colors.Green;
            } else if (isHovered) {
              tileBackground = "rgba(255, 255, 255, 0.12)";
            }

            return (
              <button
                key={item.id}
                type="button"
                onClick={() => {
                  window.open(item.href, "_blank", "noopener,noreferrer");
                }}
                onMouseEnter={() => setHoveredId(item.id)}
                onMouseLeave={() => {
                  setHoveredId(null);
                  setPressedId(null);
                }}
                onMouseDown={(e) => {
                  e.preventDefault();
                  setPressedId(item.id);
                }}
                onMouseUp={(e) => {
                  e.preventDefault();
                  setPressedId(null);
                }}
                style={{
                  display: "inline-flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  width: 96,
                  padding: 6,
                  gap: 10,
                  background: tileBackground,
                  border: `1px solid ${borderColor}`,
                  cursor: "pointer",
                  boxSizing: "border-box",
                }}
              >
                {/* OUTER outline hugging inner frame */}
                <div
                  style={{
                    padding: 1,
                    background: "#000000",
                    boxSizing: "border-box",
                    borderTop: "1px solid #808080",   // dark gray top
                    borderLeft: "1px solid #808080",  // dark gray left
                    borderRight: "1px solid #000000", // black right
                    borderBottom: "1px solid #000000",// black bottom
                  }}
                >
                  {/* INNER beveled box (matches Projects icons) */}
                  <div
                    style={{
                      width: 67.5,
                      height: 67.5,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      background: "#000000",
                      borderTop: "1px solid #C0C0C0",
                      borderLeft: "1px solid #C0C0C0",
                      borderRight: "1px solid #808080",
                      borderBottom: "1px solid #808080",
                      boxSizing: "border-box",
                    }}
                  >
                    <img
                      src={item.iconSrc}
                      alt={item.label}
                      style={{
                        maxWidth: "100%",
                        maxHeight: "100%",
                        imageRendering: "pixelated",
                        display: "block",
                      }}
                    />
                  </div>
                </div>

                <span
                  style={{
                    color: theme.colors.White,
                    textAlign: "center",
                    fontFamily: theme.fonts.body,
                    fontSize: 13,
                    fontWeight: 400,
                    lineHeight: 1.2,
                    whiteSpace: "normal",
                    wordBreak: "break-word",
                  }}
                >
                  {item.label}
                </span>
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
}
